import { styled } from "@mui/styles";
import { Button } from "@mui/material";


export const SurveyButton = styled(Button)(({ theme }) => ({
  color: "#238CB9",
  backgroundColor: "#fff !important",
  width: "260px",
  borderRadius: 23,
  paddingTop: "18px",
  paddingBottom: "18px",
  textTransform: "lowercase",
  boxShadow: "0px 3px 20px #00000026 !important",
  "&:hover": {
    backgroundColor: '#FFAB9D',
    boxShadow: "0px 3px 20px #00000026 !important",
  },
  "&:active": {
    boxShadow: "0px 3px 20px #00000026 !important",
  },
}));
